export default __webpack_public_path__ + "static/media/ChaltenPrototype20.1b6977c8.jpg";